export default "__VITE_ASSET__f3f41510__"